import { useMutation, gql } from '@apollo/client';

export const ADD_MAD_DOCUMENT = gql`
  mutation useAddMadDocument($input: AddMadDocumentInput!) {
    addMadDocument(input: $input) {
      document {
        id
        url
      }
    }
  }
`;

export default (options) => {
  return (
    useMutation(ADD_MAD_DOCUMENT, options)
  );
}
